/// <reference path='../productBundles.module.ts' />
/// <reference path='../../../../../typings/index.d.ts' />

module Meevo.Plugins.ProductBundles {
    enum AssemblyTypeEnum {
        Assemble,
        Disassemble
    }
    class AssemblyManagementModalController {
        public assemblyTypeEnum: AssemblyTypeEnum;
        public quantity: any; // todo
        public bundleId:any;
        public variantId: Guid;
        public model: any;

        static $inject = [
            '$scope', '$mdDialog', 'meevo.components.busy.BusyService', 'meevo.components.common.DataService', '$timeout'
        ];
        constructor(protected $scope: ng.IScope,
            protected $mdDialog: ng.material.IDialogService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            private dataService: Meevo.Components.BaseClasses.IDataService,
            protected $timeout: ng.ITimeoutService) {
            this.dataService = dataService;
        }

        /**
         * Close modal window
         * */
        public closeModal(): void {
            this.$mdDialog.cancel();
        }

        saveModal(): void {
            this.busyService.start();
            let data: { assemblyTypeEnum: AssemblyTypeEnum, quantity: any, id:any } = {
                assemblyTypeEnum: this.assemblyTypeEnum,
                quantity: this.assemblyTypeEnum === AssemblyTypeEnum.Assemble ? this.quantity : this.quantity*(-1),
                id: this.variantId
            };
            this.dataService.customMethodData("api/ProductBundles/" + this.bundleId +"/Assemble","POST", data)
                .then((response) => {
                    if (response.data) {  
                        this.$timeout(() => {
                            this.model.variants[0].onHand = response.data.variants[0].onHand;
                        }, 1);
                        data.quantity = 0;
                      
                    }
                }).finally(() => this.busyService.stop());
           
            this.$mdDialog.hide(data);
        }

        get assemblyTypeEnumGet(): any {
            return AssemblyTypeEnum;
        }
    }

    angular.module('meevo.plugins.productBundles')
        .controller('meevo.plugins.productBundles.AssemblyManagementModalController', AssemblyManagementModalController);
}
